import initActionServices from './actions';
import initCollectionServices from './collections';
import initFilterServices from './filters';
import initServiceRegistry, { services } from './register';
import initWidgetServices from './widgets';

export { initActionServices, initFilterServices, initServiceRegistry, initWidgetServices, services };

const initBaseServices = () => {
  initServiceRegistry();

  initActionServices();
  initFilterServices();
  initWidgetServices();
  initCollectionServices();
};

export default initBaseServices;
